import {Route, Routes} from "react-router-dom";
import RequireAuth from "../../components/RequireAuth";
import UserDetails from "./UserDetails";
import UserList from "./UserList";
import UserCreate from "./UserCreate";
import {PermissionLevel} from "../../app/api/model/user";

export default function Users() {
    return (
        <RequireAuth permissionLevel={PermissionLevel.ADMIN}>
            <Routes>
                <Route index element={<UserList />} />
                <Route path=":userId" element={<UserDetails />} />
                <Route path="new" element={<UserCreate />} />
            </Routes>
        </RequireAuth>
    );
}
